import React from 'react';
import '../styles/About.css';

const About = () => {
  return (
    <div className="container">
      <div className="about-container">
      <h2 className="about-heading">About Us</h2>
      <p className="about-text">
      Welcome to the culinary revolution! At our site, we're not
       just promoting food; we're igniting a passion for the extraordinary. 
      </p>
      <p className="about-text">
      Picture this: your business, showcased in all its glory, with its signature 
      dish taking center stage. We're here to turn that dish into a legend, driving 
      throngs of eager customers straight to your door or website. How, you ask? 
      </p>
      <p className="about-text">
      Through the unrivaled power of Google, the captivating allure of social media, 
      the electrifying reach of television, and the timeless charm of radio. We're 
      not just promoting a product; we're crafting an experience, a sensation that 
      will have mouths watering and hearts racing. 
      </p>
      <p className="about-text">
      Join us in this exhilarating journey as we elevate 
      your food business to dizzying new heights of success!
      </p>
      {/* Add more content here */}
    </div>
    </div>
  );
};

export default About;
